/**
 * Created by zhqmac on 2018/5/11.
 */
import React from 'react';
import {
    Route,
} from 'react-router-dom';
import Flow from './controllers/Flow';
const styles = {
    container: {
        display:"flex",
        flex:1,
    },

};

const AppRoutes = (
    <div style={styles.container}>
        <Route exact path="/" component={Flow}/>
        <Route path="/home" component={Flow}/>
    </div>
);

export default AppRoutes;
